// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"81":"cbad3ba2","465":"fc5cd0dc","810":"e9812fbf","910":"a581c6d2"}[chunkId] + ".css";
};